<template>
  <div>
    <div>

      <div class="layout-breadcrumb">
        <Breadcrumb>
          <Breadcrumb-item href="#" >
            <span style="color:#fff;">系统管理</span>
          </Breadcrumb-item>
          <Breadcrumb-item href="#">
          <span style="color:#fff;">系统日志</span>
          </Breadcrumb-item>
        </Breadcrumb>
      </div>

      <div class="layout-content">

        <div class="layout-content-main">

          <div class="method-wrapper">
            <div style="display:inline-block;">
             <template>
                <Input v-model="key" placeholder="用户名、用户操作" style="width: 300px"></Input>
            </template>
            <Button type="ghost" class="mRight mLeft" @click="showKeyList()" v-if="isbutShow.selectBut">查询</Button>
            </div>
          </div>

          <div class="clearfix"></div>

          <div class="table-wrapper">
            <Table style="min-width: 700px" border :columns="columns7" :data="pagerData.data" ref="selection" @on-selection-change="getSelection"></Table >
            <div style="margin: 10px;overflow: hidden">
                <div style="float: right;">
                     <Page :total="pagerData.page.totalCount" @on-change="onChange"  show-sizer show-elevator show-total  @on-page-size-change="sizeChange"></Page>
                </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
  .table-wrapper {
    overflow: scroll;
  }

  .method-wrapper {
    float: left;
    margin-bottom: 10px;
  }

  .clearfix:after {
    content: ".";
    display: block;
    height: 0;
    visibility: hidden;
    clear: both;
  }
  .mRight{
    margin-right:10px;
  }
  .mLeft{
    margin-left:10px;
  }
  .ivu-breadcrumb a{
    color:#fff !important;
  }
</style>
<script>
  import api from '../../api/apinew'
  import treeCom from '../../components/tree'
  export default{
    data(){
      return {
        isbutShow:{
        addBut: false,
        delBut: false,
        updateBut: false,
        selectBut: false,
       },
       permissionsLists:[],
        key:'',
        pagerData:{
           data:[],
           page:{
              //分页数
               // arrPageSize:[10,20,30,40],
               //分页大小
               pagesize:10,
               //总分页数
               pageCount:1,
               //当前页面
               pageCurrent:1,
               //总数
               totalCount:0
           }

        },
        columns7: [
            {
                title: 'ID',
                // type: 'index',
                key:'id',
                width: 60,
                align: 'center'
            },
            {
                title: '用户名',
                width: 80,
                key: 'username',
                align: 'center'
            },
            {
                title: '用户操作',
                width: 120,
                key: 'operation',
                align: 'center'
            },
            {
                title: '请求方法',
                key: 'method',
                align: 'center'
            },
            {
                title: '请求参数',
                key: 'params',
                align: 'center'
            },
            {
                title: '执行时长',
                key: 'time',
                width: 120,
                align: 'center'
            },
            {
                title: 'IP地址',
                key: 'ip',
                width: 120,
                align: 'center'
            },
            {
                title: '创建时间',
                key: 'createTime',
                width: 160,
                align: 'center'
            },
        ],
        modal_loading: false,

      }
    },
    mounted:function(){
       // ----------- 权限显示start -------------
      var permissions = JSON.parse(localStorage.getItem('menuLeftLists'));
      // 获取当前的地址
      let path = this.$route.matched[1].path ;
      // console.log(this.permissionsLists)
      var len = permissions.length;
     
      for(var i=0;i<len;i++){
          if(path.indexOf(permissions[i].url) != -1){
             this.permissionsLists =  permissions[i].list
          }
      }
      // console.log(this.permissionsLists)
      // 获取权限
      this.permissionsLists.forEach(r=>{
        console.log(r.name)
        if(r.name == "查看"){
          this.isbutShow.selectBut = true;
        }else if(r.name == "新增"){
          this.isbutShow.addBut = true;
        }else if(r.name == "修改"){
          this.isbutShow.updateBut = true;
        }else if(r.name == "删除"){
           this.isbutShow.delBut = true;
        }

      })
       // ----------- 权限显示end -------------
        this.getLists(this.pagerData.page.pageCurrent,this.pagerData.page.pagesize);
    },
    methods: {
        getLists(pageCurrent,pagesize){
            api.sysLog.getLists({
                'page':pageCurrent,
                'limit':pagesize,
            }, resp => {
              // 获取分页展示list
               this.pagerData.data = resp.page.list;
               // 获取分页总条数
               this.pagerData.page.totalCount = resp.page.totalCount;
            }, error => {

            })
        },
        // 搜索关键词
        showKeyList(){
            // if(this.key == ''){
            //   this.getLists(this.pagerData.page.pageCurrent,this.pagerData.page.pagesize);
            // }else{
              // console.log('通过关键词获取列表')
               api.sysLog.getLists({
                    'page':this.pagerData.page.pageCurrent,
                    'limit':this.pagerData.page.pagesize,
                    'key':this.key,
                    // 'token':token
                }, resp => {
                  // console.log(resp)
                  // 获取分页展示list
                   this.pagerData.data = resp.page.list;
                   // 获取分页总条数
                   this.pagerData.page.totalCount = resp.page.totalCount;
                   //this.key = '';
                }, error => {

                })

            //}
        },
        // 分页 -- 页数改变
        onChange:function(curpage){
            // alert("当前页面页码是：" + curpage);
            this.pagerData.page.pageCurrent = curpage;
            this.getLists(this.pagerData.page.pageCurrent,this.pagerData.page.pagesize);
        },
        // 分页 -- pageSize 改变
        sizeChange:function(size){
         // alert("当前页面size是：" + size);
          this.pagerData.page.pagesize = size;
          this.getLists(this.pagerData.page.pageCurrent,this.pagerData.page.pagesize);
        },
        getSelection:function(selection){
          // console.log(222)
            console.log(selection)
            this.selectionRows = selection;
            // return selection;
        },
    },
      components: {treeCom}
    }
</script>



// WEBPACK FOOTER //
// systemLog.vue?6f1fefa8